export { default } from './Masthead'



// WEBPACK FOOTER //
// ./src/components/Masthead/index.ts